import { ref } from 'vue';
import { projectStorage } from '../firebase/config';

const use_job_ads_storage = () => {
    const imageUrl = ref(null);
    const imageFilePath = ref(null);
    const cvUrl = ref(null);
    const cvPath = ref(null);
    const error = ref(null);

    const sanitize = str => str.replace(/\//g, '').replace(/\s+/g, '_').replace(/\.{2,}/g, '');

    // Upload ad image — waits for Resize Images extension (_375x375)
    const uploadAdImage = async (file, adTitle) => {
        imageUrl.value = null;
        imageFilePath.value = `job_ads/${sanitize(adTitle)}/${file.name}`;
        const storageRef = projectStorage.ref(imageFilePath.value);

        try {
            await storageRef.put(file);
            imageUrl.value = await waitForResizedURL(imageFilePath.value);
        } catch (err) {
            error.value = err.message;
            throw err;
        }
    };

    // Upload CV — direct upload, no resize
    const uploadCV = async (file, adId) => {
        const timestamp = Date.now();
        cvPath.value = `job_ads/applications/${adId}/${timestamp}_${file.name}`;
        const storageRef = projectStorage.ref(cvPath.value);

        try {
            const res = await storageRef.put(file);
            cvUrl.value = await res.ref.getDownloadURL();
        } catch (err) {
            error.value = err.message;
            throw err;
        }
    };

    // Delete a file by storage path
    const deleteFile = async (path) => {
        const storageRef = projectStorage.ref(path);
        try {
            await storageRef.delete();
        } catch (err) {
            error.value = err.message;
        }
    };

    async function waitForResizedURL(path, interval = 4000, timeout = 120000, startTime = Date.now()) {
        const resizedBeforeExt = path.replace(/(\.[\w\d_-]+)$/i, '_375x375$1');
        const resizedAfterExt = path.replace(/(\.[\w\d_-]+)$/i, '$&_375x375');

        try {
            const ref = projectStorage.ref(resizedBeforeExt);
            const url = await ref.getDownloadURL();
            if (url.includes('_375x375')) return url;
        } catch (err) {
            if (err.code !== 'storage/object-not-found') throw err;
        }

        try {
            const ref = projectStorage.ref(resizedAfterExt);
            const url = await ref.getDownloadURL();
            if (url.includes('_375x375')) return url;
        } catch (err) {
            if (err.code === 'storage/object-not-found' && Date.now() - startTime <= timeout) {
                await new Promise(resolve => setTimeout(resolve, interval));
                return waitForResizedURL(path, interval, timeout, startTime);
            }
            throw err;
        }

        if (Date.now() - startTime > timeout) {
            throw new Error('Timeout waiting for resized image.');
        }

        await new Promise(resolve => setTimeout(resolve, interval));
        return waitForResizedURL(path, interval, timeout, startTime);
    }

    return { imageUrl, imageFilePath, cvUrl, cvPath, error, uploadAdImage, uploadCV, deleteFile };
};

export default use_job_ads_storage;
